import { render, staticRenderFns } from "./PricePhoneBar.vue?vue&type=template&id=3b83e4a0&scoped=true&"
import script from "./PricePhoneBar.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PricePhoneBar.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PricePhoneBar.vue?vue&type=style&index=0&id=3b83e4a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b83e4a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b83e4a0')) {
      api.createRecord('3b83e4a0', component.options)
    } else {
      api.reload('3b83e4a0', component.options)
    }
    module.hot.accept("./PricePhoneBar.vue?vue&type=template&id=3b83e4a0&scoped=true&", function () {
      api.rerender('3b83e4a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PricePhoneBar.vue"
export default component.exports